import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/css/styles.css';
import './assets/css/premium-theme.css';
import './assets/css/homepage.css';
import './assets/css/functions-library.css';
import './assets/css/shortcut-base.css';
import './assets/css/shortcuts-library.css';
import './assets/css/excel-skill-test.css';
import './assets/css/mobile-responsive.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
